//
//
//
//
//
//

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('BaseButton', component.exports)
}
export default {
  name: "BaseButton",
}
